// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"Amenity_with-ellipsis---sb","withEllipsis":"Amenity_with-ellipsis---sb","popup":"Amenity_popup---sb","rtl":"Amenity_rtl---sb","amenity":"Amenity_amenity---sb","include-name":"Amenity_include-name---sb","includeName":"Amenity_include-name---sb","icon":"Amenity_icon---sb","amenities-extra-info":"Amenity_amenities-extra-info---sb","amenitiesExtraInfo":"Amenity_amenities-extra-info---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Amenities/Amenity/styles.less
// module id = 1446
// module chunks = 0